import Progress from '@components/Progress'
import { ProgramContentProp } from '@layouts/LearningPath/ProgramContent/index'
import {
  Container,
  CourseEndDate,
  FlexCompletion,
  FlexContainer,
  FlexProgressContainer,
  FlexScore,
  FlexScoreLabel,
  ProgressLabel,
} from '@layouts/LearningPath/ProgramContent/style'
import { DATE_FORMAT } from '@utils/constants'
import moment from 'moment'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import { useLPContext } from '../Layout/Context/LPContext'

const FlexModuleProgress: React.FC<ProgramContentProp> = ({ Path, Elective }) => {
  const EndDate = Path?.ContractEndDate ? (
    <>
      <FormattedMessage id="Course end date:" />
      <span>{moment(Path.ContractEndDate, DATE_FORMAT.BASIC).format(DATE_FORMAT.DEFAULT)}</span>
    </>
  ) : null

  const { lpModule } = useLPContext()

  const percent = () => Path?.getModuleProgress(lpModule)
  return (
    <Container isElective={Boolean(Elective)}>
      <FlexContainer>
        <FlexProgressContainer>
          <ProgressLabel>
            <FormattedMessage id="Module completion" />
            <CourseEndDate>
              <Row>
                <Col md={12} xs={false}>
                  {EndDate}
                </Col>
              </Row>
            </CourseEndDate>
          </ProgressLabel>
          <Progress color="brandSecondary" percent={percent()} size="lg" />
          <ProgressLabel>
            <Row>
              <Col md={false} xs={12}>
                <CourseEndDate>{EndDate}</CourseEndDate>
              </Col>
            </Row>
          </ProgressLabel>
        </FlexProgressContainer>
        <FlexCompletion>
          <FlexScore>{percent()}%</FlexScore>
          <FlexScoreLabel>
            <FormattedMessage id="completed" />
          </FlexScoreLabel>
        </FlexCompletion>
      </FlexContainer>
    </Container>
  )
}

export default FlexModuleProgress
